import { render, staticRenderFns } from "./mySubmit.vue?vue&type=template&id=e4e5b9b6&scoped=true"
import script from "./mySubmit.vue?vue&type=script&lang=js"
export * from "./mySubmit.vue?vue&type=script&lang=js"
import style0 from "./mySubmit.vue?vue&type=style&index=0&id=e4e5b9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e5b9b6",
  null
  
)

export default component.exports